module.exports = __webpack_public_path__ + "static/media/hikvision1.252c9dc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contenido/hikvision1.jpg
// module id = 378
// module chunks = 0